import { ApiClientProps } from "hooks/useApi";
import { GetCheckMatchPropsResponse as checkMatchDataProps } from "./getCheckMatch";

export interface CheckMatchMenuGroupMapProps {
  [menuGroupId: string]: {
    menuGroupId: string | null;
    value: string | null;
  };
}

interface GetLocationsProps {
  checkMatchData?: checkMatchDataProps;
  newMapping: CheckMatchMenuGroupMapProps;
  partnerId?: string;
  apiClient: ApiClientProps;
}

async function updateCheckMatch({
  checkMatchData,
  newMapping,
  partnerId,
  apiClient,
}: GetLocationsProps): Promise<void> {
  if (!checkMatchData || !newMapping || !partnerId) {
    throw new Error(
      "Network failure. Please check your connection and ensure your request includes all required parameters."
    );
  }

  const { locationId } = checkMatchData;

  const path = `/middleware-admin/partners/${partnerId}/check-match/mappings/${locationId}`;

  const body = JSON.stringify({
    ...checkMatchData,
    checkMatchMenuGroupMap: newMapping,
  });

  try {
    const response = await apiClient.put({
      path,
      headers: {
        "Content-Type": "application/json",
      },
      body,
      noRetry: true,
    });

    return response.resource;
  } catch (error) {
    throw new Error(error as string);
  }
}

export default updateCheckMatch;
